import React from 'react'
import { Button, Input, Label, Card, CardHeader, CardContent, Badge, Switch, Table, Th, Td, Tr, Tabs, Tooltip, Modal, Checkbox, Radio, Select, DateInput, Separator, Pagination, Progress, Slider, Textarea, DropdownMenu, Popover, Skeleton, SoftColorBordered, ThemeToggle, LoadingCandles, MessageEditor, RichTextEditor, FloatingActionButton } from '@/shared/ui'
import { Avatar } from '@/shared/ui/Avatar'
import { Sidebar, SidebarBody, SidebarLink, SidebarLogo, SidebarSection } from '@/shared/ui/Sidebar'
import { AccordionItem } from '@/shared/ui/Accordion'
import { DraggableList } from '@/shared/ui/DraggableList'
import { useToast } from '@/shared/ui/Toast'
import { Pencil } from 'lucide-react'

export default function GlobalComponentsGallery() {
  const [open, setOpen] = React.useState(false)
  const { add: toast } = useToast()
  const [page, setPage] = React.useState(1)
  const [radio, setRadio] = React.useState('a')
  const [checked, setChecked] = React.useState(true)
  const [select, setSelect] = React.useState('1')
  const [progress, setProgress] = React.useState(40)
  const [slider, setSlider] = React.useState(50)
  const [dragItems, setDragItems] = React.useState([
    { id: 'item-1', label: 'Item 1' },
    { id: 'item-2', label: 'Item 2' },
    { id: 'item-3', label: 'Item 3' },
  ])
  return (
    <div className="space-y-6">
      <section>
        <h3 className="mb-2 text-sm font-medium">Botões</h3>
        <div className="flex flex-wrap gap-2">
          <Button onClick={()=> toast({ title: 'Toast', description: 'Exemplo exibido com sucesso.' })}>Primário</Button>
          <Button variant="outline">Outline</Button>
          <ThemeToggle />
        </div>
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">Floating Action Button</h3>
        <div className="flex items-center gap-3">
          <FloatingActionButton
            label="Exemplo FAB"
            className="static bottom-auto right-auto bg-lime-500 text-black hover:bg-lime-400 focus-visible:ring-lime-500"
          >
            <Pencil className="h-5 w-5" />
          </FloatingActionButton>
          <span className="text-xs text-foreground/60">Exemplo estatico sem posicao fixa.</span>
        </div>
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">Inputs</h3>
        <div className="grid max-w-md gap-2">
          <Label>Seu nome</Label>
          <Input placeholder="Digite aqui" />
          <Label>Comentário</Label>
          <Textarea rows={3} placeholder="Escreva algo" />
          <Label>Data</Label>
          <DateInput />
          <Label>Seleção</Label>
          <Select value={select} onChange={(e)=> setSelect(e.target.value)}>
            <option value="1">Opção 1</option>
            <option value="2">Opção 2</option>
          </Select>
          <div className="flex items-center gap-4 pt-2">
            <label className="flex items-center gap-2 text-sm">
              <Checkbox checked={checked} onChange={(e)=> setChecked((e.target as HTMLInputElement).checked)} />
              <span>Checkbox</span>
            </label>
            <label className="flex items-center gap-2 text-sm">
              <Radio name="rg" value="a" checked={radio==='a'} onChange={()=> setRadio('a')} /> A
            </label>
            <label className="flex items-center gap-2 text-sm">
              <Radio name="rg" value="b" checked={radio==='b'} onChange={()=> setRadio('b')} /> B
            </label>
          </div>
        </div>
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">Cards & Badge</h3>
        <Card>
          <CardHeader>Exemplo de Card <Badge className="ml-2">Novo</Badge></CardHeader>
          <CardContent>Conteúdo do card</CardContent>
        </Card>
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">Breadcrumb</h3>
        <Separator />
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">Switch</h3>
        <Switch />
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">Tabela</h3>
        <Table>
          <thead>
            <Tr><Th>Coluna A</Th><Th>Coluna B</Th></Tr>
          </thead>
          <tbody>
            <Tr><Td>1</Td><Td>2</Td></Tr>
          </tbody>
        </Table>
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">Tabs</h3>
        <Tabs tabs={[{value:'a',label:'A'},{value:'b',label:'B'}]} defaultValue={'a'} />
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">Tooltip & Modal</h3>
        <Tooltip content="Dica">Passe o mouse aqui</Tooltip>
        <div>
          <Button className="mt-2" onClick={()=> setOpen(true)}>Abrir Modal</Button>
          <Modal open={open} onOpenChange={setOpen} className="p-6">
            <div className="text-lg font-semibold">Exemplo de Modal</div>
            <div className="mt-2">Conteúdo do modal.</div>
          </Modal>
        </div>
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">Pagination, Progress & Slider</h3>
        <div className="flex flex-wrap items-center gap-4">
          <Pagination page={page} total={5} onChange={setPage} />
          <Progress value={progress} className="w-40" />
          <Slider value={slider} onChange={(e:any)=> setSlider(Number(e.target?.value || 0))} className="w-40" />
        </div>
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">Dropdown & Popover</h3>
        <DropdownMenu
          trigger={<Button variant="outline">Abrir Dropdown</Button>}
          items={[{label:'Ação 1', onSelect:()=>{}},{label:'Ação 2'}]}
        />
        <span className="ml-3" />
        <Popover trigger={<Button variant="outline">Abrir Popover</Button>} content={<div>Conteúdo popover</div>} />
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">Avatar & Skeleton</h3>
        <div className="flex items-center gap-4">
          <Avatar fallback="U" />
          <Skeleton className="h-6 w-32" />
        </div>
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">Loader de Candles</h3>
        <div className="rounded-md border border-border p-4">
          <LoadingCandles className="min-h-[200px]" />
        </div>
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">MessageEditor (editor global de rich text)</h3>
        <div className="rounded-md border border-border p-4">
          <DemoEditor />
        </div>
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">BaseFileUpload</h3>
        <Card><CardContent className="pt-4">(Exemplo de uso no contexto real de upload)</CardContent></Card>
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">Badges Soft</h3>
        <SoftColorBordered />
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">Accordion</h3>
        <div className="max-w-md rounded-md border border-border p-2">
          <AccordionItem title="Título 1" defaultOpen>Conteúdo 1</AccordionItem>
          <AccordionItem title="Título 2">Conteúdo 2</AccordionItem>
        </div>
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">DraggableList</h3>
        <DraggableList items={dragItems} onReorder={(ids: string[])=> setDragItems(ids.map((id: string) => dragItems.find(i=>i.id===id)!))} />
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium">Sidebar (prévia mínima)</h3>
        <div className="rounded-md border border-border">
          <Sidebar>
            <SidebarBody className="p-3">
              <div>
                <SidebarLogo />
                <SidebarSection>
                  <SidebarLink link={{ label:'Exemplo', to:'#' }} />
                </SidebarSection>
              </div>
            </SidebarBody>
          </Sidebar>
        </div>
      </section>
    </div>
  )
}

function DemoEditor() {
  const [val, setVal] = React.useState('<p>Escreva algo <strong>rico</strong> aqui…</p>')
  return (
    <div>
      <RichTextEditor value={val} onChange={setVal} />
      <div className="mt-2 text-xs text-foreground/70">HTML atual: {val.length} caracteres</div>
    </div>
  )
}
